module.exports = __webpack_public_path__ + "static/Matlab-cf6d5af239f266001b4fda427e13c2e2.svg";